import React from 'react';

var AvatarImage = function AvatarImage(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        url = _ref.url,
        onError = _ref.onError;
    return React.createElement('img', {
        alt: '',
        className: 'avatar-image ' + className,
        src: url,
        onError: function (_onError) {
            function onError(_x) {
                return _onError.apply(this, arguments);
            }

            onError.toString = function () {
                return _onError.toString();
            };

            return onError;
        }(function (event) {
            if (typeof onError === 'function') {
                onError(event);
            }
        })
    });
};

AvatarImage.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string.isRequired,
    onError: PropTypes.func
};
export default AvatarImage;
import PropTypes from 'prop-types';